// Lightweight environment-aware logger.
// In development it forwards to the console; in production it stays silent
// so we don't leak internal app state to end users.

const isProd = process.env.NODE_ENV === 'production';

export const logger = {
  info: (...args) => {
    if (!isProd) console.info(...args);
  },
  warn: (...args) => {
    if (!isProd) console.warn(...args);
  },
  error: (...args) => {
    if (!isProd) console.error(...args);
  },
};

export default logger;
